const INDEED = 'indeed';
const BOOST = 'boost';
const SPRING = 'spring';
const REACH = 'reach';
const JOVEO = 'joveo';
const TALROO = 'talroo';
const VONQ = 'vonq';
const ZIPRECRUITER = 'zip_recruiter';
const POOL = 'pool';
const OTHER = 'other';

export {
  BOOST,
  INDEED,
  JOVEO,
  OTHER,
  POOL,
  REACH,
  SPRING,
  TALROO,
  VONQ,
  ZIPRECRUITER,
};
